const getOEMBadge = (oem) => {
  switch (oem == null ? '' : oem.toLowerCase()) {
    case 'audi':
      return 'https://assets.zappyride.com/img/oems/Audi.png';
    case 'bmw':
      return 'https://assets.zappyride.com/img/oems/BMW.png';
    case 'cadillac':
      return 'https://assets.zappyride.com/img/oems/Cadillac.png';
    case 'chevrolet':
      return 'https://assets.zappyride.com/img/oems/Chevrolet.png';
    case 'chrysler':
      return 'https://assets.zappyride.com/img/oems/Chrysler.png';
    case 'fiat':
      return 'https://assets.zappyride.com/img/oems/Fiat.png';
    case 'ford':
      return 'https://assets.zappyride.com/img/oems/Ford.png';
    case 'honda':
      return 'https://assets.zappyride.com/img/oems/Honda.png';
    case 'hyundai':
      return 'https://assets.zappyride.com/img/oems/Hyundai.png';
    case 'lincoln':
      return 'https://assets.zappyride.com/img/oems/Lincoln.png';
    case 'jaguar':
      return 'https://assets.zappyride.com/img/oems/Jaguar.png';
    case 'karma':
      return 'https://assets.zappyride.com/img/oems/Karma.png';
    case 'kia':
      return 'https://assets.zappyride.com/img/oems/Kia.png';
    case 'mini':
      return 'https://assets.zappyride.com/img/oems/Mini.png';
    case 'mercedes-benz':
      return 'https://assets.zappyride.com/img/oems/Mercedes-Benz.png';
    case 'mitsubishi':
      return 'https://assets.zappyride.com/img/oems/Mitsubishi.png';
    case 'nissan':
      return 'https://assets.zappyride.com/img/oems/Nissan.png';
    case 'porsche':
      return 'https://assets.zappyride.com/img/oems/Porsche.png';
    case 'polestar':
      return 'https://assets.zappyride.com/img/oems/Polestar.png';
    case 'smart':
      return 'https://assets.zappyride.com/img/oems/Smart.png';
    case 'subaru':
      return 'https://assets.zappyride.com/img/oems/Subaru.png';
    case 'tesla':
      return 'https://assets.zappyride.com/img/oems/Tesla.png';
    case 'toyota':
      return 'https://assets.zappyride.com/img/oems/Toyota.png';
    case 'volkswagen':
      return 'https://assets.zappyride.com/img/oems/Volkswagen.png';
    case 'volvo':
      return 'https://assets.zappyride.com/img/oems/Volvo.png';
    default:
      return '';
  }
};
export default getOEMBadge;
